var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveDynamic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_1013_339)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1013_339",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1013_339",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1013_339",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADFUlEQVR4nO3ZT4iNURzG8eM2ZkqkLDQUSVkIC2UjFoQlO2Wyt7EwKVmR5SALG2UnWSmWJDESCxt/FhZTSslcI+W/jL9fvXXUNN2Ze8+9v+553vf9fbZ3eu75PZ079z3nhuCcc84555xzzg5wE2gCz4EHwFXgPHAKOALsB7YDG4CVQMPw7esD2EGaaeA18BS4BVwBTuSeoxSAe/RmNPcMpQDs7KHkl8BQ7hnqsKtHcq+9Drv6iX85JopPFp8Ti96V+j61BWyKj3SpbuReeykA62PBf7so+Q+wOfcM0oA1wEXgN927lHsOWcCqeOIrDhy9+A6szj2PHGC4i4I/zPPamdwzSQGWxfuKTwkFfwHGgKXA3Ravvy9yc88mAVgMHG+zK2f7Fnf98hk521r83dFQd8AQcAiYSij4R/xiXDFH5viMv633URtYGAueTCj4J3AZWNvBIea/g6GOgEa8K36R+PxbPDuvS3if8Xgl2qhjwSPARELBxaHkWnF53+V99Z5QJ8Bu4DFpbgNbcq+9FOL/yvuJBT8sbuRyr70UgK3AncSCHwF7c6+9FIqPevzRNMUzYB+wQGD9g8Dp+KPvXCbj4WgwxwI3AtcTb9QmgANKTwWxwE6Nqd+ovYrPzwNBTJudPNubfh02zgG/EhbWBA5n+ch1iET9WNDZhPW8A44Bi4I4xaLfdrCOj8BJYEkoCQSLnu8C6Gv8UindtSSCRbf6dp6OV5bDoaQQLHoglt2Mu/tCFX4mQq1oNRgdNLzoPh00vOg+HTS86DasCvKi2/Ci+wTf0V50peA72ouWgNhBo7JPHYgdNKxy5CB20LDKkYNYQVY5chAryCpHDmIFWeXIQawgqxw5iBVklSMHsYKscsxU9aCBUY6Zqh40MMoxU9WDBkY5ZtQGQyzHjNpgiOWYURsMsRwzaoMhlmNGbTDEcsyoDYZYjhm1wRDLMaM2GGI5ZtQGQyzHjNpgiOWYURsMsRwzaoMhlmNGbTDEcsyoDYZYjhm1wRDLMaM2GGI5ZtQGQyzHjNpgiOU455xzzjnnnHPOhRr4B8jC6QDHUmCOAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveDynamic);
export default __webpack_public_path__ + "static/media/positive_dynamic.f91fda38e85106068e88fdc28c832e68.svg";
export { ForwardRef as ReactComponent };